import api from './authService';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const vendorIntegrationsApi = {
  get: async () => {
    const response = await api.get('/vendor/integrations');
    return response.data;
  },
  update: async (payload) => {
    const response = await api.put('/vendor/integrations', payload);
    return response.data;
  },
  syncSheets: async () => {
    const response = await api.post('/vendor/integrations/sheets/sync');
    return response.data;
  },
};

export const useVendorIntegrations = (options = {}) =>
  useQuery({
    queryKey: ['vendorIntegrations'],
    queryFn: () => vendorIntegrationsApi.get(),
    staleTime: 20_000,
    ...options,
  });

export const useUpdateVendorIntegrations = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: vendorIntegrationsApi.update,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['vendorIntegrations'] });
      queryClient.invalidateQueries({ queryKey: ['vendorWorkspace', 'automations'] });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
};

export const useSyncVendorSheets = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: vendorIntegrationsApi.syncSheets,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['vendorIntegrations'] });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
};
